import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import bind from "memoize-bind";

import st from "lib/utils/index";
import CSSModules from "lib/utils/css-modules";
import Rating from "lib/components/Rating";
import { Link } from "lib/components/vendor";
import { open as openEditReviewModal } from "modules/reviews/EditReviewModal";
import styles from "./ReviewsList.less";

@connect(null, (dispatch) =>
  bindActionCreators(
    {
      openEditReviewModal,
    },
    dispatch
  )
)
@CSSModules(styles)
export default class ReviewsList extends React.PureComponent {
  handleReviewClick(review) {
    this.props.openEditReviewModal(review);
  }

  render() {
    const { reviews, ...rest } = this.props;
    return (
      <div styleName="list">
        {reviews.map((review) => (
          <div styleName="item" key={review.id} onClick={bind(this.handleReviewClick, this, review)}>
            <div styleName="item-side">
              <div styleName="item-rating">
                <Rating value={review.rating} />
              </div>
            </div>
            <div styleName="item-main">
              <div styleName="item-headers">
                {review.product_name && (
                  <div styleName="item-title">
                    {review.product_id && (
                      <Link
                        to={`/c/${st.authorize.company.id}/products/${review.product_id}/edit`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {review.product_name}
                      </Link>
                    )}
                    {!review.product_id && review.product_name}
                  </div>
                )}

                {review.company.id !== st.authorize.company.id && (
                  <div styleName="item-meta">
                    {I18n.humanAttributeName("review", "supplier")}:&nbsp;
                    <Link to={`/c/${review.company.id}`} onClick={(e) => e.stopPropagation()}>
                      {review.company.name}
                    </Link>
                  </div>
                )}
              </div>

              <div styleName="item-content">{review.content}</div>

              <div styleName="item-metas">
                <span styleName="item-meta">
                  <strong>{review.author_name || I18n.humanAttributeName("review", "anonymous")}</strong>,{" "}
                  {moment(review.created_at).fromNow()}
                </span>
                {review.verified && (
                  <strong styleName="item-meta">{I18n.humanAttributeName("review", "verified")}</strong>
                )}
                {review.age_group && <span styleName="item-meta">{review.age_group_i18n}</span>}
                {review.group_type && <span styleName="item-meta">{review.group_type_i18n}</span>}
                {review.order_id && (
                  <span styleName="item-meta">
                    <Link
                      to={`/c/${st.authorize.company.id}/orders/${review.order_id}/${review.order_token}`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {I18n.humanAttributeName("review", "order")} #{review.order_id}
                    </Link>
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/list/ReviewsList.jsx